import { useStaticQuery } from "gatsby";
var useCmsSpotlight = function useCmsSpotlight() {
    var _useStaticQuery = useStaticQuery("2564995746"), allDatoCmsSpotlight = _useStaticQuery.allDatoCmsSpotlight;
    return allDatoCmsSpotlight.nodes && allDatoCmsSpotlight.nodes.length > 0 ? allDatoCmsSpotlight.nodes[0] : undefined;
};
export default useCmsSpotlight;
